export default "__VITE_ASSET__BTadR2fl__"